import {useDispatch} from "react-redux";
import {change} from "../redux/slices/loading.slice";

export const useLoading = () => {
    const dispatch = useDispatch()
    const start = () => {
        dispatch(change({isLoading: true}));
    }

    const stop = () => {
        dispatch(change({isLoading: false}));
    }

    return {
        start,
        stop
    }
}